<template>
	<div class="preview-edu-modal">
		<el-dialog width="504px" :visible.sync="previewModal" :before-close="handleClose" :show-close="false" v-el-drag-dialog :close-on-click-modal='false'>
      <div slot="title" class="preview-modal-title">
        <span class="modal-title-icon" @click="closeModal">
          <i class="el-icon-circle-close"></i>
        </span>
      </div>
			<img class="preview-modal-img" :onerror="errorImgRectangle" :src="previewImageUrl" alt="">
		</el-dialog>
	</div>
</template>

<script>
export default {
  name: 'previewModal',
  props: {
    previewModal: {
      type: Boolean,
      default: false
    },
    previewImageUrl: {
      type: String
    }
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.$emit('previewClose')
    },
    // 关闭弹窗
    closeModal() {
      this.$emit('previewClose')
    }
  },
}
</script>

<style lang="scss">
.preview-edu-modal {
  .el-dialog__header {
    padding: 0;
    position: relative;
    .preview-modal-title {
      display: inline-block;
      position: absolute;
      top: -24px;
      right: -24px;
      .modal-title-icon {
        color: #fff;
        font-size: 24px;
        cursor: pointer;
      }
    }
  }
  .el-dialog__body {
    text-align: center;
    padding: 12px 16px;
    font-size: 0;
    .preview-modal-img {
      background-color: rgba(0, 0, 0, .2);
      max-width: 100%;
      max-height: 600px;
    }
  }
}
</style>
